module.exports = {
      id: "stories-usage",
      viewBox: "0 0 33 27.835",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#stories",
      toString: function () {
        return this.url;
      }
    }